<template>
  <form @submit.prevent="handleSubmit(item)">
        <div class="form-group">
      <label
        for="info_label"
        class="form-control-label">Unique identifier</label>
        <input
          required
          id="info_label"
          v-model="item.uniqueIdentifier"
          :class="['form-control', !isValid('uniqueIdentifier') ? 'is-invalid' : 'is-valid']"
          type="text"
          placeholder="">
      <div
        v-if="!isValid('uniqueIdentifier')"
        class="invalid-feedback">{{ violations.uniqueIdentifier }}</div>
    </div>
    <div class="form-group">
      <label
        for="info_label"
        class="form-control-label">Label</label>
        <input
          required
          id="info_label"
          v-model="item.label"
          :class="['form-control', !isValid('label') ? 'is-invalid' : 'is-valid']"
          type="text"
          placeholder="">
      <div
        v-if="!isValid('label')"
        class="invalid-feedback">{{ violations.label }}</div>
    </div>
    <div class="form-group">
      <label
        for="info_link"
        class="form-control-label">Link</label>
        <input
          required
          id="info_link"
          v-model="item.link"
          :class="['form-control', !isValid('link') ? 'is-invalid' : 'is-valid']"
          type="text"
          placeholder="">
      <div
        v-if="!isValid('link')"
        class="invalid-feedback">{{ violations.link }}</div>
    </div>     

    <button
      type="submit"
      class="btn btn-success">Submit</button>
  </form>
</template>

<script>
  import ImageUploader from '../image-uploader/ImageUploader';
  import { find, get, isUndefined } from 'lodash';
  import { mapFields } from 'vuex-map-fields';
  import { mapActions } from 'vuex';
  import apiUrl from '../../store/modules/links/links';

export default { 
  data() {
    return {      
      itemImage: '',      
    }
  },   
  props: {
    handleSubmit: {
      type: Function,
      required: true,
    },

    values: {
      type: Object,
      required: true,
    },

    errors: {
      type: Object,
      default: () => {},
    },

    initialValues: {
      type: Object,
      default: () => {},
    },  
  },

  created() {
    // console.log(this.item);
    this.imageGetSelectItems();
    if (this.item.image != null) {
      this.itemImage = this.item.image['@id'];
    } else {
      this.itemImage = ''      
    }   
  },
  mounted() {    
    this.getCurrentImagePath();        
  },
  components: {
		'image-uploader': ImageUploader,		
	},
  computed: {
    ...mapFields('mediaobject/list', {
      'imageSelectItems': 'selectItems',
    }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    violations() {
      return this.errors || {};
    },
  },

  methods: {
    ...mapActions({
        imageGetSelectItems: 'mediaobject/list/getSelectItems',
    }),

    isSelected(collection, id) {
      return find(this.item[collection], ['@id', id]) !== undefined;
    },

    isValid(key) {
      return isUndefined(get(this.violations, key));
    },

    imageUrlChanged(e) {
      console.log(e);      
      this.itemImage = apiUrl.API_HOST + '/media/' + e.filePath;
      // this.itemImageId = e['@id'];
      this.item.image = e['@id'];
      // console.log(this.itemImageId);
    },

    getCurrentImagePath() {      
      this.imageSelectItems.forEach(imageObject => {       
        if (imageObject['@id'] == this.itemImage) {
          this.itemImage = apiUrl.API_HOST + '/media/' + imageObject['filePath'];          
        }        
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/info/Form.vue